import crypto from 'crypto-browserify';
import CryptoJS from 'crypto-js';

function encrypt(algorithm: string, password: string, value: string): string {
  const cipher = crypto.createCipher(algorithm, password);
  let crypted = cipher.update(value, 'utf8', 'hex');
  crypted += cipher.final('hex');
  return crypted;
}

export function decrypt(algorithm: string, password: string, value: string): string {
  const decipher = crypto.createDecipher(algorithm, password);
  let dec = decipher.update(value, 'hex', 'utf8');
  dec += decipher.final('utf8');
  return dec;
}

const getAlgorithmMode = (algorithm: string) => {
  switch (algorithm) {
    case 'aes-256-ctr':
      return CryptoJS.mode.CTR;
    default:
      return '';
  }
};

export const jsEncrypt = (algorithm: string, pass: string, IV: string, msg: string) => {
  const algorithmMode = getAlgorithmMode(algorithm);
  try {
    pass = CryptoJS.enc.Utf8.parse(pass);
    IV = CryptoJS.enc.Utf8.parse(IV);
    const options = { mode: algorithmMode, iv: IV };
    const json = CryptoJS.AES.encrypt(msg, pass, options);
    return json.ciphertext.toString();
  } catch (err) {
    return '';
  }
};

export const jsDecrypt = (algorithm: string, pass: string, IV: string, hex: string) => {
  try {
    const decipher = CryptoJS.createDecipheriv(algorithm, pass, IV);
    const dec = decipher.update(hex, 'hex', 'utf8');
    return dec + decipher.final('utf8');
  } catch (err) {
    return '';
  }
};

export default {
  encrypt,
  decrypt,
  jsEncrypt,
  jsDecrypt
};
